/* LIFT LINE — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const overlay = () => $('[data-overlay]');

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || (window.theme && window.theme.moneyFormat) || '¥{{amount_no_decimals}}';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (n, d, ts = ',', ds = '.') => {
      n = (n / 100).toFixed(d);
      const parts = n.split('.');
      const i = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + ts);
      return parts[1] ? i + ds + parts[1] : i;
    };
    const m = format.match(re);
    if (!m) return format;
    let v = '';
    switch (m[1]) {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.'); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'"); break;
      default: v = fmt(cents, 0);
    }
    return format.replace(re, v);
  }

  /* ---------- Drawers / modals ---------- */
  let lastFocus = null;
  function openPanel(id) {
    const el = document.getElementById(id);
    if (!el) return false;
    closeAll();
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    overlay().hidden = false;
    document.body.classList.add('is-locked');
    setTimeout(() => {
      const f = el.querySelector('input[type=search]') || el;
      f.focus();
    }, 50);
    return true;
  }
  function closeAll() {
    $$('.drawer.is-open, .search-modal.is-open').forEach((d) => d.classList.remove('is-open'));
    if (overlay()) overlay().hidden = true;
    document.body.classList.remove('is-locked');
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      if (openPanel(opener.dataset.open)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]') || e.target.matches('[data-overlay]')) {
      closeAll();
      if (lastFocus) lastFocus.focus();
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------- Header shadow ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Cart ---------- */
  async function refreshCount() {
    try {
      const cart = await fetch(window.theme.routes.cart + '.js').then((r) => r.json());
      $$('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count > 0 ? cart.item_count : ''));
    } catch (_) {}
  }
  function renderDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer]');
    const current = $('[data-cart-drawer]');
    if (fresh && current) {
      const wasOpen = current.classList.contains('is-open');
      current.innerHTML = fresh.innerHTML;
      if (wasOpen) current.classList.add('is-open');
    }
  }
  const hasDrawer = () => window.theme.cartType === 'drawer' && $('[data-cart-drawer]');

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || !hasDrawer()) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const errorBox = form.querySelector('[data-form-error]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.dataset.label = btn.innerHTML; btn.innerHTML = '<span class="spinner"></span>'; }
    const fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(window.theme.routes.cartAdd + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      if (errorBox) errorBox.hidden = true;
      let sections = data.sections;
      const max = window.theme.maxQty || 0;
      if (max && data.quantity > max) {
        const r2 = await fetch(window.theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: data.key, quantity: max, sections: 'cart-drawer' }) });
        const d2 = await r2.json();
        sections = d2.sections;
      }
      renderDrawer(sections && sections['cart-drawer']);
      await refreshCount();
      openPanel('CartDrawer');
    } catch (err) {
      if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
    } finally {
      if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = btn.dataset.label; }
    }
  });

  async function changeLine(key, qty) {
    let q = Math.max(0, parseInt(qty, 10) || 0);
    if (window.theme.maxQty) q = Math.min(q, window.theme.maxQty);
    const body = { id: key, quantity: q };
    const inDrawer = !!$('[data-cart-drawer]');
    if (inDrawer) body.sections = 'cart-drawer';
    const res = await fetch(window.theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await res.json();
    if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
    if (inDrawer) renderDrawer(data.sections && data.sections['cart-drawer']);
    refreshCount();
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-change]');
    if (!b) return;
    e.preventDefault();
    b.closest('.line') && b.closest('.line').classList.add('loading');
    changeLine(b.dataset.qtyChange, b.dataset.qty);
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-qty-input]');
    if (i) changeLine(i.dataset.qtyInput, i.value);
  });

  /* ---------- Quantity stepper (product) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const max = parseInt(input.max, 10) || Infinity;
    input.value = Math.min(max, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10)));
  });

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    const main = $('[data-gallery-main]', root);
    if (!main) return;
    const slides = $$('[data-media-id]', main);
    const thumbs = $$('[data-thumb]', root);
    const counter = $('[data-gallery-count]', root);
    const go = (i) => { const s = slides[i]; if (s) main.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); };
    const current = () => Math.round(main.scrollLeft / main.clientWidth);
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    const prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    prev && prev.addEventListener('click', () => go(Math.max(0, current() - 1)));
    next && next.addEventListener('click', () => go(Math.min(slides.length - 1, current() + 1)));
    let t;
    main.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const i = current();
        thumbs.forEach((th, j) => th.setAttribute('aria-current', i === j));
        if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        if (counter) counter.textContent = i + 1 + ' / ' + slides.length;
      }, 60);
    }, { passive: true });
    root.goToMedia = (id) => { const idx = slides.findIndex((s) => s.dataset.mediaId == id); if (idx > -1) go(idx); };
  }

  /* ---------- Variant picker ---------- */
  function initProduct(root) {
    const json = $('[data-variants-json]', root);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const form = $('[data-product-form]', root);
    const idInput = form && form.querySelector('[name=id]');
    const btn = $('[data-add-btn]', root);
    const priceEl = $('[data-price-wrap]', root);
    const sticky = $('[data-sticky-atc]');
    const stickySelect = sticky && $('select', sticky);
    const stickyBtn = sticky && $('[data-sticky-btn]', sticky);
    const optionCount = parseInt(root.dataset.optionCount || '1', 10);

    const selected = () => {
      const vals = [];
      for (let i = 1; i <= optionCount; i++) {
        const c = $(`input[data-option-index="${i}"]:checked`, root);
        vals.push(c ? c.value : null);
      }
      return vals;
    };
    const markAvailability = (vals) => {
      for (let i = 1; i <= optionCount; i++) {
        $$(`input[data-option-index="${i}"]`, root).forEach((input) => {
          const test = vals.slice(); test[i - 1] = input.value;
          const match = variants.find((v) => v.options.every((o, k) => test[k] === null || o === test[k]));
          input.closest('.pill').classList.toggle('is-unavailable', !match || !match.available);
        });
      }
    };
    const update = () => {
      const vals = selected();
      $$('[data-selected-value]', root).forEach((el) => { el.textContent = vals[parseInt(el.dataset.selectedValue, 10) - 1] || ''; });
      markAvailability(vals);
      const v = variants.find((x) => x.options.every((o, k) => o === vals[k]));
      if (!v) {
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.querySelector('span').textContent = '選択できません'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (btn) {
        btn.toggleAttribute('aria-disabled', !v.available);
        if (!v.available) btn.setAttribute('aria-disabled', 'true');
        btn.querySelector('span').textContent = v.available ? btn.dataset.addText : '在庫切れ';
      }
      if (priceEl) {
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        const off = sale ? Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price) : 0;
        priceEl.innerHTML = `<div class="price${sale ? ' price--sale' : ''}"><span class="price__now">${formatMoney(v.price)}</span>${sale ? `<s>${formatMoney(v.compare_at_price)}</s><span class="badge badge--accent">${off}% OFF</span>` : ''}</div>`;
      }
      if (v.featured_media && root.goToMedia) root.goToMedia(v.featured_media.id);
      if (stickySelect) stickySelect.value = v.id;
      if (stickyBtn) { stickyBtn.toggleAttribute('disabled', !v.available); }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    root.addEventListener('change', (e) => { if (e.target.matches('[data-option-index]')) update(); });
    if (stickySelect) {
      stickySelect.addEventListener('change', () => {
        const v = variants.find((x) => x.id == stickySelect.value);
        if (!v) return;
        v.options.forEach((val, k) => {
          const input = $$(`input[data-option-index="${k + 1}"]`, root).find((i) => i.value === val);
          if (input) input.checked = true;
        });
        update();
      });
    }
    if (stickyBtn) stickyBtn.addEventListener('click', () => {
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
    markAvailability(selected());

    /* sticky visibility */
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(btn);
    }
  }

  /* ---------- Countdown (same-day shipping) ---------- */
  function initCountdown() {
    $$('[data-cutoff]').forEach((el) => {
      const hour = parseInt(el.dataset.cutoff, 10);
      const out = $('[data-countdown]', el);
      const label = $('[data-countdown-label]', el);
      const tick = () => {
        // calculate in JST
        const now = new Date();
        const jst = new Date(now.getTime() + (now.getTimezoneOffset() + 540) * 60000);
        const cut = new Date(jst); cut.setHours(hour, 0, 0, 0);
        let tomorrow = false;
        if (jst >= cut) { cut.setDate(cut.getDate() + 1); tomorrow = true; }
        const diff = Math.max(0, cut - jst);
        const h = Math.floor(diff / 3.6e6), m = Math.floor((diff % 3.6e6) / 6e4), s = Math.floor((diff % 6e4) / 1000);
        if (out) out.textContent = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
        if (label) label.textContent = tomorrow ? el.dataset.textTomorrow : el.dataset.textToday;
      };
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- FAQ tabs ---------- */
  function initTabs() {
    $$('[data-tabs]:not([data-bound])').forEach((root) => {
      root.setAttribute('data-bound', '');
      const tabs = $$('[role=tab]', root);
      tabs.forEach((tab) => tab.addEventListener('click', () => {
        tabs.forEach((t) => t.setAttribute('aria-selected', t === tab));
        $$('[role=tabpanel]', root).forEach((p) => (p.hidden = p.id !== tab.getAttribute('aria-controls')));
      }));
    });
  }

  /* ---------- Slider arrows ---------- */
  function initSliders() {
    $$('[data-slider-root]:not([data-bound])').forEach((root) => {
      root.setAttribute('data-bound', '');
      const track = $('[data-slider]', root);
      const prev = $('[data-slider-prev]', root), next = $('[data-slider-next]', root);
      if (!track || !prev || !next) return;
      const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 20 : 300);
      const upd = () => {
        prev.disabled = track.scrollLeft < 5;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', upd, { passive: true });
      upd();
    });
  }

  /* ---------- Reveal + counters ---------- */
  function initReveal() {
    const items = $$('.reveal');
    const counters = $$('[data-count-to]');
    if (!('IntersectionObserver' in window)) {
      items.forEach((i) => i.classList.add('is-in'));
      counters.forEach((c) => (c.textContent = c.dataset.countTo));
      return;
    }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      io.unobserve(en.target);
    }), { threshold: 0.12 });
    items.forEach((i) => io.observe(i));
    const co = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      const el = en.target, to = parseFloat(el.dataset.countTo), dec = (el.dataset.countTo.split('.')[1] || '').length;
      const t0 = performance.now();
      const run = (t) => {
        const p = Math.min(1, (t - t0) / 1400);
        el.textContent = (to * (1 - Math.pow(1 - p, 3))).toFixed(dec);
        if (p < 1) requestAnimationFrame(run);
      };
      requestAnimationFrame(run);
      co.unobserve(el);
    }), { threshold: 0.4 });
    counters.forEach((c) => co.observe(c));
  }

  window.themeInitSliders = () => { initSliders(); initReveal(); };

  /* ---------- Init ---------- */
  function init(scope = document) {
    $$('[data-product-root]', scope).forEach((r) => { initGallery(r); initProduct(r); });
  }
  document.addEventListener('DOMContentLoaded', () => {
    init();
    initCountdown();
    initTabs();
    initSliders();
    initReveal();
  });
  document.addEventListener('shopify:section:load', (e) => {
    init(e.target); initTabs(); initSliders(); initReveal(); initCountdown();
  });
})();
